import { Button, Input, Select, DatePicker, Row, Col } from 'antd'
import React, { useEffect, useState } from 'react'
import {
  SearchOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from '@ant-design/icons'
import {
  AGE_SEARCH_TYPE,
  COUNTRY_TYPE,
  GENDER_TYPE,
  mncmccOptions,
  PHONE_MODEL,
  source,
  userType,
} from 'src/constants'
import { getGamesCategory, getByCategoriesAll } from 'src/api/game'
import { fetchCountryProvider } from 'src/api/authen'
import { UserNameAutoComplete } from 'src/components/Search/UserNameSearch'
import { getAllGames, getListOfGames } from 'src/api/reports'

interface UserPointsReportSearchProps {
  appendSearchForm: (obj: any) => void
  submitSearchForm: () => void
}

interface Game {
  id: string
  title: string
}

const UserPointsReportSearch: React.FC<UserPointsReportSearchProps> = ({
  appendSearchForm,
  submitSearchForm,
}) => {
  const [searchType, setSearchType] = useState('Between')
  const [minAge, setMinAge] = useState('')
  const [maxAge, setMaxAge] = useState('')
  const [isCategoryMapLoading, setIsCategoryMapLoading] = useState(false)
  const [buttonAction, setButtonAction] = useState('Select')
  const [providerCountry, setProviderCountry] = useState('')
  const [userName, setUserName] = useState('')
  const [gameId, setGameId] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [listOfGames, setListOfGames] = useState([])
  const [gameCategory, setGameCategory] = useState('')
  const [listOfCategories, setListOfCategories] = useState([])
  const [categoryMap, setCategoryMap] = useState<Map<string, Set<Game>>>(
    new Map()
  )
 const [selectedFilterValue, setSelectedFilterValue] = useState('ALL');
  const [countries, setCountries] = useState([])
  const handlePdfClick = () => {
    appendSearchForm({ buttonAction: 'Generate Pdf' })
    submitSearchForm()
  }
  const fetchCategoryMap = async () => {
    try {
      setIsCategoryMapLoading(true)

      const data = await getByCategoriesAll()
      if (data) {
        const map = new Map<string, Set<Game>>()
        data.forEach((category) => {
          if (category.type && Array.isArray(category.games)) {
            category.games.forEach((game) => {
              if (!map.has(category.type)) {
                map.set(category.type, new Set())
              }
              map.get(category.type)?.add({ id: game.id, title: game.title })
            })
          }
        })
        setCategoryMap(map)
      }
    } catch (error) {
      console.error('Error fetching game category:', error)
    } finally {
      setIsCategoryMapLoading(false)
    }
  }

  const handleCsvClick = () => {
    appendSearchForm({ buttonAction: 'Generate Csv' })
    submitSearchForm()
  }
  const handleSearchClick = () => {
    appendSearchForm({ buttonAction: ' ' })
    submitSearchForm()
    setButtonAction(null)
  }

  const handleSearchTypeChange = (value: string) => {
    setSearchType(value)
    setMinAge('')
    setMaxAge('')
    setProviderCountry('')
    setUserName('')
    setGameId('')
    setStartDate('')
    setEndDate('')
    setGameCategory('')
  }

  const filterGamesByType = (type) => {
    const gameSet = categoryMap.get(type?.toUpperCase() ?? '')
    const filteredGames = gameSet ? Array.from(gameSet) : []
    setListOfGames(filteredGames)
    return filteredGames
  }

  const filterGameOption = (inputValue, option) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase())
  }

  const filterCountryOption = (inputValue, option) => {
    return option.children.toLowerCase().includes(inputValue.toLowerCase())
  }

  const handleSearchTypeClear = React.useCallback(() => {
    appendSearchForm({
      maxAge: '',
      minAge: '',
      searchType: '',
      providerCountry: '',
      userName: '',
      gameId: '',
      startDate: '',
      endDate: '',
      gameCategory: '',
    })

    submitSearchForm()
  }, [])
  useEffect(() => {
    appendSearchForm({ maxAge: '' })
    appendSearchForm({ minAge: '' })
    appendSearchForm({ searchType })
    appendSearchForm({ providerCountry: '' })
    appendSearchForm({ userName: '' })
    appendSearchForm({ gameId: '' })
    appendSearchForm({ startDate: '' })
    appendSearchForm({ endDate: '' })
    appendSearchForm({ gameCategory: '' })
  }, [searchType])

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const data = await getAllGames()
        if (data) {
          setListOfGames(data)
          
        }
      } catch (error) {
        console.error('Error fetching games:', error)
      }
    }

    fetchGames()
  },[])
  useEffect(() => {
    const fetchGameCategories = async () => {
      try {
        const data = await getGamesCategory()
        if (data) {
          const filteredCategories = data.filter(
            (category) => category !== 'Guys'
          )

          setListOfCategories(filteredCategories)
        }
      } catch (error) {
        console.error('Error fetching game category:', error)
      }
    }
    fetchGameCategories()
    const fetchCountry = async () => {
      try {
        const data = await fetchCountryProvider()
        const countryOptions = data.data.map((item) => ({
          label: item.countryName,
          value: item.countryCode,
        }))
        setCountries(countryOptions)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchCountry()
    fetchCategoryMap()
  }, [])

  const filterGameCategoryOption = (inputValue, option) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase())
  }
  const handleCategoryChange = (value) => {
    setGameCategory(value)
    const filteredGames = filterGamesByType(value)
    if (filteredGames?.length > 0) {
      appendSearchForm({
        gameCategory: filteredGames.map((game) => game.id),
      })
    } else {
      appendSearchForm({
        gameCategory: [],
      })
    }
  }
const allUserTypeOptions = [
    { label: 'All', value: 'ALL' },
    ...userType,
  ];
 
  
    const handleFilterChange = (value) => {
      setSelectedFilterValue(value);
      let userTypesForSearch;
  
      if (value === 'ALL') {
       
        userTypesForSearch = userType.map(option => option.value);
      } else {
        
        userTypesForSearch = [value];
      }
  
      appendSearchForm({ userAccessType: userTypesForSearch });
      
    };
  return (
    <div className="master-search-wrap">
      <Row gutter={15}>
        <Col span={4}>
                <UserNameAutoComplete  appendSearchForm={appendSearchForm} />
             
              </Col>
        <Col span={4}>
          <Select
            placeholder="Select Game"
            onChange={(value) => appendSearchForm({ gameId: value })}
            filterOption={filterGameOption}
            allowClear
            onClear={() => appendSearchForm({ gameId: '' })}
            className="search-input"
            showSearch
            loading={isCategoryMapLoading}
          >
            {listOfGames.map((game) => (
              <Select.Option value={game.id} key={game.id} label={game.title}>
                {game.title}
              </Select.Option>
            ))}
          </Select>
        </Col>
<Col span={4}>
          <Select
            placeholder="Provider Country"
            onChange={(value) => {
              appendSearchForm({ providerCountry: value });
              if (!value) submitSearchForm();
            }}
            allowClear
            onClear={() => {
              appendSearchForm({ providerCountry: '' });
              submitSearchForm();
            }}
            showSearch
            className="search-input"
            style={{ width: '100%' }}
          >
            {countries.map((country) => (
              <Select.Option value={country.value} key={country.value}>
                {country.label}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={8}>
          <DatePicker.RangePicker
            
            allowClear
            format="YYYY-MM-DD"
            placeholder={['Start Date', 'End Date']}
            onChange={(dates) => {
              const startDate = dates?.[0]?.format('YYYY-MM-DD') || null
              const endDate = dates?.[1]?.format('YYYY-MM-DD') || null
              appendSearchForm({ startDate, endDate })
            }}
          />
        </Col>
         <Col span={4}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearchClick}
            className="btn-primary"
            
          >
            Search
          </Button>
        </Col>

      </Row>
      
       

     
    </div>
  )
}

UserPointsReportSearch.displayName = 'UserPointsReportSearch'
export default UserPointsReportSearch
